import React from "react";
import "./UpperMiddleDashBoard.css";
export default function UpperMiddleDashBoard() {
  return (
    <div className="UpperMiddleDashBoard">
      <div className="main-dashborad-heading">
        <p  className="main-dashborad-heading-1">DashBoard</p>
        <div className="dashboard-path">
          <p className="dashBoard">DashBoard </p>
          <p className="Performance"> => Performance</p>
          <p className="Summery"> => Summery</p>
        </div>
      </div>
      <div className="sub-dashboard-boxes">
        <div className="boxes-1">
          <p className="sub-box-1">Need Review</p>
          <p className="sub-box-2">1081</p>
        </div>
        <div className="boxes-2">
          <p className="sub-box-3">Waiting List</p>
          <p className="sub-box-4">2809</p>
        </div>
        <div className="boxes-3">
          <p className="sub-box-5">Listed Merchant</p>
          <p className="sub-box-6">323</p>
        </div>
        <div className="boxes-4">
          <p className="sub-box-7">Suspended Merchant</p>
          <p className="sub-box-8">311</p>
        </div>
      </div>
    </div>
  );
}
